<!--
  AI:
  Status: "in progress"
  Type: Component
  SubType: Template
  Reason: Unified Side-Car Playground shell. One route (xx/playground) with a tab
          bar (PrimeNG p-tabs): Tab 1 "QL-Demos" embeds the existing
          <mvs-xx-sidecar-playground>; Tab 2 "Widgets" embeds the three
          self-contained side-car widgets + one framework <mvs-widget>; Tab 3
          "uf-Erfassung" embeds <mvs-xx-playground-uf> (TM-1000001960); Tab 4
          "Berufe (TAA)" embeds <mvs-xx-playground-berufe>, the search-backed
          value list demo.
-->
@if (initialized) {
    <div class="flex flex-column gap-3 p-3">

        <!-- Shell header -->
        <div class="flex flex-column gap-1">
            <h1 class="m-0">Side-Car Playground</h1>
            <span class="text-color-secondary">
                Gebündelte Demo-Oberfläche für das Clean-Core Side-Car-Muster: QL-Demos,
                Widgets und die uf-Erfassung in einer Ansicht.
            </span>
        </div>

        <!-- Tab bar -->
        <p-tabs [value]="activeTab" (valueChange)="onTabChange($any($event))">
            <p-tablist>
                @for (tab of tabs; track tab.key) {
                    <p-tab [value]="tab.key">
                        <i class="{{ tab.icon }} mr-2"></i>
                        <span>{{ tab.label }}</span>
                    </p-tab>
                }
            </p-tablist>

            <p-tabpanels>

                <!-- Tab 1: QL-Demos — existing playground component -->
                <p-tabpanel value="ql-demos">
                    <mvs-xx-sidecar-playground></mvs-xx-sidecar-playground>
                </p-tabpanel>

                <!-- Tab 2: Widgets — self-contained side-car widgets + framework widget -->
                <p-tabpanel value="widgets">
                    <div class="flex flex-column gap-4">

                        <!-- #4 External Flat -->
                        <p-panel header="Externe Flat-Felder (#4)">
                            <mvs-xx-person-external-flat></mvs-xx-person-external-flat>
                        </p-panel>

                        <!-- #5 External Typed -->
                        <p-panel header="Externe typisierte Felder (#5)">
                            <mvs-xx-person-external-typed></mvs-xx-person-external-typed>
                        </p-panel>

                        <!-- #3 Internal Typed -->
                        <p-panel header="Interne typisierte Felder (#3)">
                            <mvs-xx-person-data></mvs-xx-person-data>
                        </p-panel>

                        <!-- Framework-widget example: QL table over xx.XxPerson -->
                        <p-panel header="Framework-Widget — Personen (QL-Tabelle)">
                            <mvs-widget [widgetData]="personTableWidgetData"></mvs-widget>
                        </p-panel>

                    </div>
                </p-tabpanel>

                <!-- Tab 3: uf-Erfassung — real uf flow that materializes the side-cars -->
                <p-tabpanel value="uf">
                    <mvs-xx-playground-uf></mvs-xx-playground-uf>
                </p-tabpanel>

                <!-- Tab 4: Berufe (TAA) — search-backed value list in a real metadata-driven form -->
                <p-tabpanel value="berufe">
                    <mvs-xx-playground-berufe></mvs-xx-playground-berufe>
                </p-tabpanel>

            </p-tabpanels>
        </p-tabs>

    </div>
}
